// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2LE4s","fileBtn":"File_fileBtn__VEDWz","closeBtn":"File_closeBtn__TD_bh","fileSelected":"File_fileSelected__V1Y4c","disabled":"File_disabled__WFyDY"};